document.addEventListener("DOMContentLoaded", function () { 

/* =========================================================
  CLEAR URL
========================================================= */
if (window.location.search.includes('customer_posted=true')) {
  const url = new URL(window.location.href);
  url.searchParams.delete('customer_posted');

  window.history.replaceState(
    {},
    document.title,
    `${url.pathname}${url.search}${url.hash}`
  );
}
/* =========================================================
  SLIDE ANIMATION
========================================================= */
function cancelPanelAnimation(panel) {
  if (panel && panel._anim) {
    panel._anim.cancel();
    panel._anim = null;
  }
}
function slideTo(panel, fromPx, toPx, duration, easing) {
  cancelPanelAnimation(panel);
  panel.style.height = `${fromPx}px`;

  const anim = panel.animate(
    [{ height: `${fromPx}px` }, { height: `${toPx}px` }],
    { duration, easing, fill: 'forwards' }
  );
  panel._anim = anim;
  anim.onfinish = () => {
    panel._anim = null;
    panel.style.height = toPx > 0 ? 'auto' : '0px';
  };
  anim.oncancel = () => {
    panel._anim = null;
  };
}

/* =========================================================
  BEFORE/AFTER IMGs
============================================================ */
const initBeforeAfter = (root = document) => {
  const beforeAfterElements = root.querySelectorAll('[data-before-after]');

  beforeAfterElements.forEach((element) => {
    if (element.dataset.beforeAfterInitialized === 'true') return;

    const range = element.querySelector('.before-after__range');

    if (!range) return;

    const updatePosition = () => {
      element.style.setProperty(
        '--before-after-position',
        `${range.value}%`
      );
    };

    range.addEventListener('input', updatePosition);

    updatePosition();

    element.dataset.beforeAfterInitialized = 'true';
  });
};
initBeforeAfter();

/* =========================================================
  ACCORDION
============================================================ */
const accordionRegistry = [];
function resetAccordionGroup({
  scope = document,
  itemSelector,
  triggerSelector,
  panelSelector,
  openClass = 'open'
}) {
  if (!scope) return;

  scope.querySelectorAll(itemSelector).forEach((item) => {
    const trigger = item.querySelector(triggerSelector);
    const panel = item.querySelector(panelSelector);

    item.classList.remove(openClass);
    trigger?.setAttribute('aria-expanded', 'false');

    if (!panel) return;

    cancelPanelAnimation(panel);

    if (panel.getAnimations) {
      panel.getAnimations().forEach((anim) => anim.cancel());
    }

    panel.setAttribute('aria-hidden', 'true');
    panel.style.height = '0px';
    panel.style.overflow = 'hidden';
  });
}

function initAccordion({
  itemSelector,
  triggerSelector,
  panelSelector,
  openClass = 'open',
  durationOpen = 450,
  durationClose = 450,
  easing = 'cubic-bezier(.4, 0, .2, 1)',
  closeSiblings = true,
  defaultOpenIndex = null,
}) {
  const config = {
    itemSelector,
    triggerSelector,
    panelSelector,
    openClass,
    durationOpen,
    durationClose,
    easing,
    closeSiblings
  };

  accordionRegistry.push(config);
  const items = document.querySelectorAll(itemSelector);

  if (defaultOpenIndex !== null && items[defaultOpenIndex]) {
    const item = items[defaultOpenIndex];
    const panel = item.querySelector(panelSelector);
    const trigger = item.querySelector(triggerSelector);

    if (panel && trigger) {
      item.classList.add(openClass);
      trigger.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      panel.style.height = 'auto';
    }
  }
}
document.addEventListener('click', (e) => {
  const matchedConfig = accordionRegistry.find(({ triggerSelector, itemSelector }) => {
    const trigger = e.target.closest(triggerSelector);
    if (!trigger) return false;
    return !!trigger.closest(itemSelector);
  });
  if (!matchedConfig) return;

  const {
    itemSelector,
    triggerSelector,
    panelSelector,
    openClass,
    durationOpen,
    durationClose,
    easing,
    closeSiblings
  } = matchedConfig;

  const trigger = e.target.closest(triggerSelector);
  if (!trigger) return;

  if (trigger.tagName === 'A') {
    e.preventDefault();
  }

  const item = trigger.closest(itemSelector);
  if (!item) return;

  const panel = item.querySelector(panelSelector);
  if (!panel) return;

  const isOpen = item.classList.contains(openClass);

  if (closeSiblings) {
    document.querySelectorAll(`${itemSelector}.${openClass}`).forEach((openItem) => {
      if (openItem === item) return;

      const openPanel = openItem.querySelector(panelSelector);
      const openTrigger = openItem.querySelector(triggerSelector);
      if (!openPanel) return;

      cancelPanelAnimation(openPanel);

      openItem.classList.remove(openClass);
      openTrigger?.setAttribute('aria-expanded', 'false');
      openPanel.setAttribute('aria-hidden', 'true');

      const h = openPanel.offsetHeight;
      slideTo(openPanel, h, 0, durationClose, easing);
    });
  }

  cancelPanelAnimation(panel);

  if (isOpen) {
    const current = panel.offsetHeight;

    item.classList.remove(openClass);
    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');

    slideTo(panel, current, 0, durationClose, easing);
    return;
  }

  panel.style.height = 'auto';
  const target = panel.scrollHeight;
  panel.style.height = '0px';

  item.classList.add(openClass);
  trigger.setAttribute('aria-expanded', 'true');
  panel.setAttribute('aria-hidden', 'false');

  slideTo(panel, 0, target, durationOpen, easing);
});

/* =========================================================
  OVERLAY
========================================================= */
window.AllierUI = window.AllierUI || {};
if (!window.AllierUI.OverlayController) {
  window.AllierUI.OverlayController = function OverlayController(options) {
    const {
      root,
      panel = root,
      backdrop = null,
      trigger = null,
      openClass = 'is-open',
      closingClass = '',
      hiddenWhenClosed = false,
      lockScroll = true,
      closeOnEscape = true,
      closeOnBackdrop = true,
      trapFocus = true,
      closeDelay = 0,
      initialFocus = null,
      onOpen = () => {},
      onClose = () => {},
      onAfterClose = () => {}
    } = options || {};

    if (!root) return null;

    let isOpen = false;
    let isClosing = false;
    let lastFocusedElement = null;

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'textarea:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    function getTriggerEl() {
      return typeof trigger === 'function' ? trigger() : trigger;
    }
    function getFocusableElements() {
      return [...panel.querySelectorAll(focusableSelector)]
        .filter((el) => !el.hasAttribute('disabled') && el.offsetParent !== null);
    }
    function focusInitialElement() {
      const target =
        (typeof initialFocus === 'function' ? initialFocus() : initialFocus) ||
        getFocusableElements()[0] ||
        panel;

      if (target && typeof target.focus === 'function') {
        target.focus();
      }
    }
    function handleKeydown(e) {
      if (!isOpen) return;

      if (closeOnEscape && e.key === 'Escape') {
        e.preventDefault();
        api.close();
        return;
      }

      if (!trapFocus || e.key !== 'Tab') return;

      const focusable = getFocusableElements();
      if (!focusable.length) {
        e.preventDefault();
        panel.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;

      if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function handleBackdropClick(e) {
      if (!isOpen || !closeOnBackdrop) return;

      if (backdrop) {
        if (e.target === backdrop) {
          api.close();
        }
        return;
      }

      if (e.target === root) {
        api.close();
      }
    }

    function bindGlobalEvents() {
      document.addEventListener('keydown', handleKeydown);
      (backdrop || root).addEventListener('click', handleBackdropClick);
    }
    function unbindGlobalEvents() {
      document.removeEventListener('keydown', handleKeydown);
      (backdrop || root).removeEventListener('click', handleBackdropClick);
    }
    function setExpanded(value) {
      const triggerEl = getTriggerEl();
      if (triggerEl) {
        triggerEl.setAttribute('aria-expanded', value ? 'true' : 'false');
      }
    }

    function applyOpenState() {
      if (closingClass) {
        root.classList.remove(closingClass);
      }
      if (openClass) {
        root.classList.add(openClass);
      }
      root.setAttribute('aria-hidden', 'false');

      if (hiddenWhenClosed) {
        root.removeAttribute('hidden');
      }
      setExpanded(true);

      if (lockScroll) {
        document.body.classList.add('no-scroll');
      }
    }

    function applyClosedState() {
      if (closingClass) {
        root.classList.add(closingClass);
      }
      root.setAttribute('aria-hidden', 'true');
      setExpanded(false);

      if (lockScroll) {
        document.body.classList.remove('no-scroll');
      }
    }
      function finalizeClose({ restoreFocus = true } = {}) {
        if (openClass) {
          root.classList.remove(openClass);
        }
        if (closingClass) {
          root.classList.remove(closingClass);
        }
        if (hiddenWhenClosed) {
          root.setAttribute('hidden', '');
        }
        unbindGlobalEvents();

        isOpen = false;
        isClosing = false;

        if (
          restoreFocus &&
          lastFocusedElement &&
          typeof lastFocusedElement.focus === 'function'
        ) {
          lastFocusedElement.focus();
        }
        onAfterClose();
      }

    const api = {
      open(openedBy = null) {
        if (isOpen || isClosing) return;

        const activeOverlay = window.AllierUI.activeOverlay;
        if (activeOverlay && activeOverlay !== api) {
          activeOverlay.close({ restoreFocus: false });
        }

        lastFocusedElement = openedBy || document.activeElement;
        window.AllierUI.activeOverlay = api;

        applyOpenState();
        bindGlobalEvents();

        isOpen = true;
        isClosing = false;

        onOpen();
        requestAnimationFrame(() => {
          focusInitialElement();
        });
      },

      close({ restoreFocus = true } = {}) {
        if (!isOpen || isClosing) return;

        isClosing = true;
        onClose();

        applyClosedState();

        if (window.AllierUI.activeOverlay === api) {
          window.AllierUI.activeOverlay = null;
        }

        if (closeDelay > 0) {
          window.setTimeout(() => {
            finalizeClose({ restoreFocus });
          }, closeDelay);
        } else {
          finalizeClose({ restoreFocus });
        }
      },

      toggle(openedBy = null) {
        if (isOpen) {
          api.close();
        } else {
          api.open(openedBy);
        }
      },
      isOpen() {
        return isOpen;
      }
    };
    return api;
  };
}

// ============================
//  MOBILE MENU
// ============================
const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');
const siteOverlay = document.querySelector('[data-site-overlay]');

const mobileMenuController = window.AllierUI.OverlayController({
  root: mobileMenu,
  panel: mobileMenu,
  backdrop: siteOverlay,
  trigger: () => mobileMenuToggle,
  openClass: 'open',
  lockScroll: true,
  closeOnEscape: true,
  closeOnBackdrop: true,
  trapFocus: true,
  
  initialFocus: () => mobileMenuClose || mobileMenu?.querySelector('button, a, [tabindex]:not([tabindex="-1"])'),
  onOpen: () => {
    siteOverlay?.classList.add('is-active');
  },

  onClose: () => {
    siteOverlay?.classList.remove('is-active');

    resetAccordionGroup({
      scope: mobileMenu,
      itemSelector: '.mobile-submenu',
      triggerSelector: '.mobile-submenu-trigger',
      panelSelector: '.mobile-submenu-panel',
      openClass: 'open'
    });
  }
});

function openMobileMenu() {
  mobileMenuController?.open(mobileMenuToggle);
}

function closeMobileMenu() {
  mobileMenuController?.close();
}

if (mobileMenuToggle && mobileMenuController) {
  mobileMenuToggle.addEventListener('click', (e) => {
    e.preventDefault();
    mobileMenuController.toggle(mobileMenuToggle);
  });
}

if (mobileMenuClose) {
  mobileMenuClose.addEventListener('click', (e) => {
    e.preventDefault();
    closeMobileMenu();
  });
}

/* =========================================================
   MOBILE MENU
========================================================= */
initAccordion({
  itemSelector: '.mobile-submenu',
  triggerSelector: '.mobile-submenu-trigger',
  panelSelector: '.mobile-submenu-panel',
  openClass: 'open',
  closeSiblings: true,
});

/* ==========================
   FOOTER 
============================= */
initAccordion({
  itemSelector: '.footer-col',
  triggerSelector: '.footer-trigger',
  panelSelector: '.footer-collapse',
  openClass: 'open',
  closeSiblings: true,
  durationOpen: 350,
  durationClose: 350,
});

/* ========================
   FAQ 
=========================== */
initAccordion({
  itemSelector: '.faq-item',
  triggerSelector: '.faq-question',
  panelSelector: '.faq-answer',
  openClass: 'open',
  closeSiblings: true,
  durationOpen: 350,
  durationClose: 350,
});

/* =========================
   PRODUCT DETAILS (PDP)
============================ */
initAccordion({
  itemSelector: '.product-details-accordion__item',
  triggerSelector: '.product-details-accordion__trigger',
  panelSelector: '.product-details-accordion__panel',
  openClass: 'open',
  closeSiblings: true,
  defaultOpenIndex: 0
});

/* =======================
   CART NOTE
========================== */
initAccordion({
  itemSelector: '.cart-note-accordion',
  triggerSelector: '.cart-note-accordion__summary',
  panelSelector: '.cart-note-accordion__content',
  openClass: 'open',
  closeSiblings: false,
  durationOpen: 350,
  durationClose: 350,
});
document.querySelectorAll(
  '.faq-item.open .faq-answer, ' +
  '.cart-note-accordion.open .cart-note-accordion__content, ' +
  '.product-details-accordion__item.open .product-details-accordion__panel'
).forEach((panel) => {
  panel.style.height = 'auto';
  panel.setAttribute('aria-hidden', 'false');
});

/* ==================================================
   SWIPE GESTURE
================================================== */
let touchStartX = 0;
let touchStartY = 0;
let gestureTarget = null;

const swipeThreshold = 80;
const verticalTolerance = 35;
const horizontalRatio = 1.6;

function isInGestureExcludedArea(target) {
  return !!target.closest('.swiper, .swiper-wrapper, .swiper-slide');
}

document.addEventListener('touchstart', (e) => {
  if (!e.touches || e.touches.length !== 1) return;

  const target = e.target;
  if (isInGestureExcludedArea(target)) {
    gestureTarget = null;
    return;
  }
  const menuIsOpen = mobileMenu?.classList.contains('open');
  const miniCart = document.getElementById('mini-cart');
  const miniCartIsOpen = miniCart?.classList.contains('is-open');

  if (menuIsOpen && target.closest('[data-mobile-menu]')) {
    gestureTarget = 'mobile-menu';
  } else if (miniCartIsOpen && target.closest('#mini-cart')) {
    gestureTarget = 'mini-cart';
  } else {
    gestureTarget = null;
    return;
  }
  touchStartX = e.touches[0].clientX;
  touchStartY = e.touches[0].clientY;
}, { passive: true });

document.addEventListener('touchend', (e) => {
  if (!gestureTarget) return;
  if (!e.changedTouches || e.changedTouches.length !== 1) return;

  const t = e.changedTouches[0];
  const deltaX = t.clientX - touchStartX;
  const deltaY = Math.abs(t.clientY - touchStartY);
  const absDeltaX = Math.abs(deltaX);

  const target = gestureTarget;
  gestureTarget = null;

  if (absDeltaX < swipeThreshold) return;
  if (deltaY > verticalTolerance) return;
  if (absDeltaX / Math.max(deltaY, 1) < horizontalRatio) return;

  if (target === 'mobile-menu' && deltaX < 0) {
    closeMobileMenu();
    return;
  }
  if (target === 'mini-cart' && deltaX > 0) {
    window.closeMiniCart?.();
  }
}, { passive: true });

// ============================
// TOPBAR 
// ============================
(function initHeaderScroll() {
  const topbar = document.querySelector('.topbar');
  const header = document.querySelector('.header-container');
  if (!topbar || !header) return;

  let lastY     = window.scrollY;
  let ticking   = false;
  let hidden    = false;
  const THRESHOLD = 6;

  let topbarH = topbar.offsetHeight;
  document.documentElement.style.setProperty('--topbar-h', `${topbarH}px`);

  function update() {
    ticking = false;
    const y     = window.scrollY;
    const delta = y - lastY;

    if (Math.abs(delta) < THRESHOLD) return;

    if (y <= topbarH) {
      topbar.classList.remove('hidden');
      header.style.transform = '';
      hidden = false;
      lastY = y;
      return;
    }
    const shouldHide = delta > 0 && y > topbarH;
    if (shouldHide !== hidden) {
      hidden = shouldHide;

      if (hidden) {
        topbar.classList.add('hidden');
        header.style.transform = `translateY(-${topbarH}px)`;
      } else {
        header.style.transform = topbar.classList.contains('hidden')
          ? `translateY(-${topbarH}px)`
          : '';
      }
    }
    lastY = y;
  }
  
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });

  window.addEventListener('resize', () => {
    topbarH = topbar.offsetHeight;
    document.documentElement.style.setProperty('--topbar-h', `${topbarH}px`);
  }, { passive: true });
})();

// ============================
// HERO SLIDER
// ============================
function initHeroSwiper() {
  const swiperEl = document.querySelector(".hero-swiper");
  if (!swiperEl) return;

  const slidesCount = parseInt(swiperEl.dataset.slidesCount || "0", 10);
  const hasMultipleSlides = slidesCount > 1;
  const progressBar = document.querySelector(".hero-progress-bar");
  const currentEl = document.querySelector(".hero-current");

  const swiper = new Swiper(swiperEl, {
    loop: hasMultipleSlides,
    allowTouchMove: hasMultipleSlides,
    autoplay: hasMultipleSlides
      ? {
        delay: 5000,
        disableOnInteraction: false,
      }
    : false,
      speed: 800,
      effect: "slide",
  });

  if (!hasMultipleSlides) return;

  function updateSlideNumber(swiper) {
    if (!currentEl) return;
    const index = swiper.realIndex + 1;
    currentEl.textContent = index.toString().padStart(2, "0");
  }
  swiper.on("slideChange", () => {
    updateSlideNumber(swiper);
  });
  swiper.on("autoplayTimeLeft", (_, time, progress) => {
    if (progressBar) {
      progressBar.style.width = `${(1 - progress) * 100}%`;
    }
  });

  updateSlideNumber(swiper);
}
initHeroSwiper();

//=========================
// WIDGET BAR 
//=========================
function initWidgetsSwiper() {
  const swiperEl = document.querySelector(".widgets-swiper");
  if (!swiperEl) return;

  let swiperInstance = null;

  function enableSwiper() {
    if (swiperInstance) return;

    swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      watchOverflow: true,
        breakpoints: {
          800:  { slidesPerView: 2, spaceBetween: 16 }
        },
      pagination: {
        el: ".widgets-pagination",
        clickable: true,
      },
    });
  }
  function destroySwiper() {
    if (!swiperInstance) return;
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  }

  function checkBreakpoint() {
    if (window.innerWidth >= 1024) destroySwiper();
    else enableSwiper();
  }
  checkBreakpoint();

  let t = null;
  window.addEventListener("resize", () => {
    clearTimeout(t);
    t = setTimeout(checkBreakpoint, 150);
  });
}
initWidgetsSwiper();

// ============================
//    FAQ
// ============================
function initFAQ() {
  const categories = document.querySelectorAll(".customerSupport-category");
  const faqItems = document.querySelectorAll(".faq-item");

  if (!faqItems.length) return;

  // ============================
  // FILTER BY CATEGORY
  // ============================
  categories.forEach(cat => {
    cat.addEventListener("click", () => {
      const targetID = cat.getAttribute("data-category");

      categories.forEach(c => c.classList.remove("active"));
      cat.classList.add("active");

      faqItems.forEach(faq => {
        const answer = faq.querySelector(".faq-answer");

        // reset accordion
        faq.classList.remove("open");
        if (answer) answer.style.height = "0px";

        // filter
        faq.style.display =
          faq.dataset.category === targetID ? "block" : "none";
      });
    });
  });

  if (categories[0]) {
    categories[0].click();
  }
}
initFAQ();

/* ==================================================
    SEARCH DROPDOWN
=====================================================*/
const searchDropdown = document.getElementById("search-dropdown");
const searchTriggers = document.querySelectorAll(".header-search-trigger");
const searchCloseBtn = searchDropdown?.querySelector(".search-dropdown-close");
const searchInput = searchDropdown?.querySelector(".search-dropdown-input");

if (searchDropdown && searchTriggers.length > 0) {
  let closeTimeout;

  const setExpandedState = (expanded) => {
    searchTriggers.forEach((trigger) => {
      trigger.setAttribute("aria-expanded", String(expanded));
    });
  };

  const isOpen = () => searchDropdown.classList.contains("open");

  const openDropdown = () => {
    clearTimeout(closeTimeout);

    searchDropdown.classList.remove("closing");
    searchDropdown.classList.add("open");
    setExpandedState(true);

    setTimeout(() => {
      searchInput?.focus();
    }, 150);
  };

  const closeDropdown = () => {
    clearTimeout(closeTimeout);

    searchDropdown.classList.add("closing");

    // Lo stato accessibile viene aggiornato immediatamente.
    setExpandedState(false);

    closeTimeout = setTimeout(() => {
      searchDropdown.classList.remove("open", "closing");
    }, 250);
  };

  // Initial State
  setExpandedState(isOpen());
  // Trigger open/close
  searchTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      isOpen() ? closeDropdown() : openDropdown();
    });
  });

  // Button Close
  searchCloseBtn?.addEventListener("click", (event) => {
    event.preventDefault();
    closeDropdown();
  });

  // Escape
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && isOpen()) {
      closeDropdown();
    }
  });

  // Extern click
  document.addEventListener("click", (event) => {
    if (!isOpen()) return;
    if (searchDropdown.contains(event.target)) return;
    if ([...searchTriggers].some((trigger) => trigger.contains(event.target))) return;
    closeDropdown();
  });
  searchDropdown.addEventListener("click", (event) => {
    event.stopPropagation();
  });
}

/* ======================================================
    PARALLAX
========================================================= */
const EditorialHeroParallax = (() => {
  const selector = '[data-editorial-parallax="true"]';

  const PARALLAX_SPEED = 0.18;
  const LERP_FACTOR = 0.12;
  const ROOT_MARGIN = '24% 0px';
  const EPSILON = 0.05;
  const FRAME_DURATION = 1000 / 60;
  const MAX_FRAME_DELTA = 64;

  const items = new Map();
  const active = new Set();

  let observer;
  let frameId = null;
  let lastTimestamp = 0;
  let ready = false;

  const schedule = () => {
    if (frameId === null) {
      frameId = requestAnimationFrame(update);
    }
  };

  const scan = (root, callback) => {
    root.matches?.(selector) && callback(root);
    root.querySelectorAll?.(selector).forEach(callback);
  };

  function getTargetY(viewportHeight, rect) {
    const progress = Math.max(
      -1,
      Math.min(
        1,
        (viewportHeight - (2 * rect.top) - rect.height) /
          (viewportHeight + rect.height)
      )
    );
    return progress * rect.height * PARALLAX_SPEED;
  }

  function render(item, y) {
    if (Math.abs(y - item.renderedY) < 0.01) return;

    item.media.style.transform = `translate3d(0, ${y.toFixed(3)}px, 0)`;
    item.renderedY = y;
  }
  function update(timestamp) {
    frameId = null;

    const viewportHeight = window.innerHeight;
    const deltaTime = lastTimestamp
      ? Math.min(timestamp - lastTimestamp, MAX_FRAME_DELTA)
      : FRAME_DURATION;

    const easedLerp =
      1 - Math.pow(1 - LERP_FACTOR, deltaTime / FRAME_DURATION);

    const updates = [];
    lastTimestamp = timestamp;

    active.forEach((hero) => {
      const item = items.get(hero);
      if (!item) return;

      const rect = hero.getBoundingClientRect();
      const targetY = getTargetY(viewportHeight, rect);

      if (!item.isInitialized) {
        item.currentY = targetY;
        item.isInitialized = true;
      }

      item.targetY = targetY;
      updates.push(item);
    });

    let needsAnotherFrame = false;

    updates.forEach((item) => {
      const distance = item.targetY - item.currentY;

      if (Math.abs(distance) <= EPSILON) {
        item.currentY = item.targetY;
      } else {
        item.currentY += distance * easedLerp;
        needsAnotherFrame = true;
      }
      render(item, item.currentY);
    });
    if (needsAnotherFrame) {
      schedule();
    }
  }

  function add(hero) {
    if (items.has(hero)) return;
    const media = hero.querySelector('.section-editorial-hero__media');
    if (!media) return;

    items.set(hero, {
      media,
      currentY: 0,
      targetY: 0,
      renderedY: Number.NaN,
      isInitialized: false,
    });
    if (observer) {
      observer.observe(hero);
    } else {
      active.add(hero);
    }
  }
  function remove(hero) {
    observer?.unobserve(hero);
    active.delete(hero);
    items.delete(hero);
  }

  function init() {
    if (
      ready ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }
    ready = true;

    observer = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            active[isIntersecting ? 'add' : 'delete'](target);
          });
          schedule();
        }, {
          rootMargin: ROOT_MARGIN,
        })
      : null;

    scan(document, add);

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('orientationchange', schedule);

    ['load', 'unload'].forEach((action) => {
      document.addEventListener(`shopify:section:${action}`, ({ target }) => {
        scan(target, action === 'load' ? add : remove);
      });
    });
    document.addEventListener('shopify:section:reorder', schedule);
    schedule();
  }
  return { init };
})();
EditorialHeroParallax.init();

/* ======================================================
    POPUP
========================================================= */
function initSitePopup() {
  const root = document.documentElement;
  const popup = document.getElementById('SitePopup');
  if (!popup) return;

  const panel = popup.querySelector('.site-popup__panel');
  const backdrop = popup.querySelector('.site-popup__backdrop');
  if (!panel) return;

  const delay = Number(popup.dataset.popupDelay || 0);
  const frequencyDays = Number(popup.dataset.popupFrequencyDays || 0);
  const storageKey = 'allier_site_popup_closed_at';
  const closeEls = popup.querySelectorAll('[data-popup-close]');

  const now = Date.now();
  const closedAt = Number(localStorage.getItem(storageKey) || 0);
  const msWindow = frequencyDays > 0 ? frequencyDays * 86400000 : 0;

  if (msWindow > 0 && closedAt && (now - closedAt) < msWindow) return;

  let isOpen = false;
  let isClosing = false;
  let lastActiveEl = null;

  function onKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      closePopup();
    }
  }
  function onDocumentClick(e) {
    if (!isOpen || isClosing) return;
    if (!panel.contains(e.target) && !e.target.closest('[data-popup-close]')) {
      closePopup();
    }
  }
  function openPopup() {
    if (isOpen || isClosing) return;

    lastActiveEl = document.activeElement;

    popup.removeAttribute('hidden');
    popup.setAttribute('aria-hidden', 'false');

    void popup.offsetWidth;

    popup.classList.add('is-open');
    root.classList.add('is-popup-open');
    document.body.classList.add('no-scroll');

    document.addEventListener('keydown', onKeydown);
    document.addEventListener('click', onDocumentClick);

    if (typeof panel.focus === 'function') {
      panel.focus();
    }
    isOpen = true;
  }

  function finishClose() {
    popup.setAttribute('hidden', '');
    popup.setAttribute('aria-hidden', 'true');
    popup.classList.remove('is-open');

    root.classList.remove('is-popup-open');
    document.body.classList.remove('no-scroll');

    document.removeEventListener('keydown', onKeydown);
    document.removeEventListener('click', onDocumentClick);

    if (lastActiveEl && typeof lastActiveEl.focus === 'function') {
      lastActiveEl.focus();
    }

    isOpen = false;
    isClosing = false;
  }

  function closePopup() {
    if (!isOpen || isClosing) return;

    isClosing = true;
    localStorage.setItem(storageKey, String(Date.now()));

    popup.classList.remove('is-open');
    root.classList.remove('is-popup-open');
    document.body.classList.remove('no-scroll');

    const onEnd = (e) => {
      if (e.target !== panel || e.propertyName !== 'transform') return;
      panel.removeEventListener('transitionend', onEnd);
      finishClose();
    };

    panel.addEventListener('transitionend', onEnd);

    window.setTimeout(() => {
      if (isClosing) {
        panel.removeEventListener('transitionend', onEnd);
        finishClose();
      }
    }, 350);
  }

  closeEls.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      closePopup();
    });
  });
  if (backdrop) {
    backdrop.addEventListener('click', (e) => {
      e.preventDefault();
      closePopup();
    });
  }
  window.setTimeout(openPopup, Math.max(0, delay));
}
initSitePopup();

}); // END DOMContentLoaded